<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    v-model:open="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="联系电话" name="mobile">
        <a-input
          v-model:value="form.mobile"
          disabled
          placeholder="请输入联系电话"
        />
      </a-form-item>
      <a-form-item label="注销原因" name="reason">
        <a-input
          v-model:value="form.reason"
          disabled
          type="textarea"
          placeholder="请输入注销原因"
        />
      </a-form-item>
      <a-form-item label="审核状态" name="status">
        <a-select placeholder="请选择审核状态" v-model:value="form.status">
          <a-select-option
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
            >{{ d.label }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="审核失败原因" name="failReason">
        <a-input
          v-model:value="form.failReason"
          type="textarea"
          placeholder="请输入审核失败原因"
        />
      </a-form-item>
      <!--      <a-form-item label="备注" name="remark" >-->
      <!--        <a-input v-model:value="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { getCancel, addCancel, updateCancel } from '@/api/biz/cancel'

const props = defineProps({
  statusOptions: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)

const form = reactive({
  id: null,
  mobile: null,
  reason: null,
  status: 0,
  failReason: null,
  remark: null,
})

const rules = {
  mobile: [
    { required: true, message: '联系电话不能为空', trigger: 'blur' },
    {
      pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      message: '请正确填写联系电话',
      trigger: 'blur',
    },
  ],
  reason: [
    { required: true, message: '注销原因不能为空', trigger: 'blur' },
  ],
  status: [
    { required: true, message: '审核状态不能为空', trigger: 'blur' },
  ],
}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    mobile: null,
    reason: null,
    status: 0,
    failReason: null,
    remark: null,
  })
  nextTick(() => {
    if (formRef.value) {
      formRef.value.resetFields()
    }
  })
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getCancel({ id: id }).then((response) => {
    Object.assign(form, response.data)
    open.value = true
    formTitle.value = '审核'
  })
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    if (form.id !== undefined && form.id !== null) {
      await updateCancel(form)
      message.success('修改成功', 3)
      open.value = false
      emit('ok')
    } else {
      await addCancel(form)
      message.success('新增成功', 3)
      open.value = false
      emit('ok')
    }
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>
